<template>
  <div class="process-template">
    <div class="search-group">
      <div class="input-box">
        <el-input
          size="mini"
          placeholder="请输入模版名称"
          v-model="templateName">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <el-button type="primary" size="mini" @click="doSearch">{{"搜索"}}</el-button>
      <el-button type="primary" size="mini" @click="showDialog">{{"新增"}}</el-button>
    </div>
    <div class="table-box">
      <cc-table
        :config="tableConfig"
        :params="tableConfigParams"
        :refesh-params="tableRefresh"
      ></cc-table>
    </div>
    <el-dialog :title="`${form.id === '' ? '新增' : '编辑'}模版`"
               :visible.sync="dialogVisible"
               width="50%"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               @closed="closeDialog"
               append-to-body>
      <el-form
        :model="form"
        :rules="rules"
        size="mini"
        label-width="80px"
        ref="form"
        @submit.native.prevent
        v-loading="loading">
          <el-form-item label="模版名称" prop="templateName">
            <el-input v-model="form.templateName">
              <template slot="append">
                <el-button
                  type="primary"
                  size="mini"
                  @click.prevent="submitForm('form')"
                >{{ "提交" }}</el-button>
              </template>
            </el-input>
          </el-form-item>
      </el-form>
      <div v-if="form.id !== ''">
        <el-table
          :data="tableData"
          border
          v-loading="tableDataLoading"
          :span-method="objectSpanMethod"
          :header-cell-style="tableHeaderStyle"
          style="width: 100%;">
          <el-table-column
            v-for="column in columns"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :title="'导入工序'"
               :visible.sync="dialogUpload"
               width="20%"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               append-to-body>
      <el-upload
        v-if="dialogUpload"
        class="file"
        accept=".xlsx"
        ref="upload"
        :action="uploadUrl"
        :limit="1"
        :data="{id:tplId}"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
        <el-button style="margin-left: 10px;" size="small" @click="exportTemplate">下载模版</el-button>
        <div slot="tip" class="el-upload__tip">只能上传.xlsx格式文件</div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ProcessTemplate',
    data() {
      return {
        uploadUrl: window.location.origin + '/admin/fsb/process/template/upload',
        tplId: '',
        loading: false,
        tableDataLoading: false,
        tableRefresh: 1,
        templateName: '',
        dialogVisible: false,
        dialogUpload: false,
        form: {
          id: '',
          templateName: ''
        },
        rules: {
          templateName: [{ required: true, message: "请输入模版名称", trigger: "blur" }]
        },
        tableConfigParams: {
          templateName: ''
        },
        tableConfig: {
          showPager: true,
          pageSize: 10,
          api: "admin/fsb/process/template/query",
          columns: [
            {prop: 'templateName', lable: '模版名称', type: 'input'},
            {prop: 'processNum', lable: '工序数', type: 'input'},
            {prop: 'createUserName', lable: '创建者', type: 'input'},
            {prop: 'updateUserName', lable: '修改者', type: 'input'},
            {prop: 'createTime', lable: '创建时间', type: 'input'},
            {prop: 'updateTime', lable: '修改时间', type: 'input'}
          ],
          buttonsLabel: '操作',
          buttons: [
            {
              name: '编辑',
              click: (row) => {
                this.dialogVisible = true;
                this.$nextTick(() => {
                  this.form.id = row.id;
                  this.form.templateName = row.templateName;
                  this.tableDataLoading = true;
                  this.ccRequest
                    .do('admin/fsb/process/template/queryChildrenProcess', {
                      'processTemplateId': row.id,
                    }, 'GET').then((res) => {
                    this.tableDataLoading = false;
                    this.tableData = res.data;
                    this.getSpanArray(this.tableData, this.columns);
                  });
                });
              },
            },
            {
              name: '上传',
              click: (row) => {
                this.tplId = row.id;
                this.dialogUpload = true;
              },
            },
            {
              name: '导出',
              click: (row) => {
                window.open(window.location.origin + '/admin/fsb/process/template/exportProcess?id='+row.id);
              },
            },
            {
              name: '删除',
              click: (row) => {
                this.$confirm(`确定删除'${row.templateName}'模版?`, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }).then(() => {
                  this.ccRequest
                    .do(
                      `admin/fsb/process/template/delete`,
                      { id: row.id },
                      "GET"
                    ).then(() => {
                      this.tableRefresh = new Date().getTime();
                      this.$message({message: "删除成功", type: "success"});
                    }).catch((err) => {
                      this.$message.error(err.response.data.message);
                    });
                });
              },
            }
          ],
        },
        tableData: [],
        spanArr: [],
        columns:[
          {
            prop:'processName',
            label:'阶段',
            width:'150'
          },
          {
            prop:'content',
            label:'工序',
          },
          {
            prop:'standardWorkingHours',
            label:'标准工时',
            width:'80'
          },
          {
            prop:'limitWorkingHours',
            label:'上限工时',
            width:'80'
          }
        ]
      }
    },
    methods: {
      initForm() {
        this.form.id = '';
        this.form.templateName = '';
      },
      doSearch() {
        this.tableConfigParams.templateName = this.templateName;
      },
      showDialog() {
        this.dialogVisible = true;
      },
      closeDialog() {
        this.dialogVisible = false;
        this.$refs.form.resetFields();
        this.initForm();
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.ccRequest
              .do('admin/fsb/process/template/save', this.form, 'POSTJSON')
              .then(() => {
                this.closeDialog();
                this.tableRefresh = new Date().getTime();
                this.$message({message: '保存成功', type: 'success'});
              })
              .catch((err) => {
                this.$message.error(err.response.data.message);
              });
          }
        });
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleUploadSuccess() {
        this.dialogUpload = false;
        this.$message.success('上传工序成功');
        this.tableRefresh = new Date().getTime();
      },
      handleUploadError(err) {
        this.$message.error(JSON.parse(err.message).message)
      },
      exportTemplate() {
        window.open(window.location.origin + '/admin/fsb/process/template/exportTpl');
        this.dialogUpload = false;
      },
      getSpanArray(data, columns) {
        this.spanArr = [];
        const arr = columns.map((e) => e.prop);
        const nameObj = new Array(arr.length).fill(0);
        for (let i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanArr[0] = new Array(arr.length).fill(1);
            nameObj[0] = 0;
          } else {
            let newRow = [];
            for (let j = 0; j < arr.length; j++) {
              if (data[i][arr[j]] === data[i - 1][arr[j]] && (arr[j] === 'processName')) {
                this.spanArr[nameObj[j]][j] += 1;
                newRow.push(0);
              } else {
                newRow.push(1);
                nameObj[j] = i;
              }
            }
            this.spanArr.push(newRow);
          }
        }
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        const _row = this.spanArr[rowIndex][columnIndex];
        const _col = _row > 0 ? 1 : 0;
        return { rowspan: _row, colspan: _col };
      },
      tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
        return 'background-color: #F5F7FA; color: #6f6f6f';
      }
    }
  }
</script>

<style scoped lang="scss">
.el-upload__tip {
  position: absolute;
  top: 50px;
  color: red;
}
.process-template {
  background: #fff;
  padding: 20px;

  .input-box {
    margin-right: 20px;
  }

  .search-group {
    display: flex;
    margin-bottom: 20px;
  }
}

::v-deep .el-table .el-table__cell {
  padding: 6px 0;
}

</style>
